/**
 * Main Renderer
 *
 * Coordinates all rendering subsystems
 */

import { LaneRenderer } from './LaneRenderer';
import { NoteRenderer } from './NoteRenderer';
import { UIRenderer } from './UIRenderer';
import { Note } from '../gameplay/Note';

export class Renderer {
  private ctx: CanvasRenderingContext2D;
  private laneRenderer: LaneRenderer;
  private noteRenderer: NoteRenderer;
  private uiRenderer: UIRenderer;

  constructor(ctx: CanvasRenderingContext2D) {
    this.ctx = ctx;
    this.laneRenderer = new LaneRenderer();
    this.noteRenderer = new NoteRenderer();
    this.uiRenderer = new UIRenderer();
  }

  /**
   * Render gameplay screen
   */
  renderGameplay(notes: Note[], score: number, combo: number, accuracy: number): void {
    // Clear with gradient background
    this.renderBackground();

    // Render lanes
    this.laneRenderer.render(this.ctx);

    // Render notes
    this.noteRenderer.render(this.ctx, notes);

    // Render UI
    this.uiRenderer.render(this.ctx, score, combo);
    this.uiRenderer.renderAccuracy(this.ctx, accuracy);
  }

  /**
   * Show judgment feedback
   */
  showJudgment(judgment: string): void {
    this.uiRenderer.showJudgment(judgment);
  }

  private renderBackground(): void {
    const gradient = this.ctx.createLinearGradient(0, 0, 0, this.ctx.canvas.height);
    gradient.addColorStop(0, '#0f0f1e');
    gradient.addColorStop(1, '#1a1a2e');

    this.ctx.fillStyle = gradient;
    this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
  }
}
